import { repositoryFactory } from '@/repositories/repositoryFactory'

export default {
    data: () => ({
        repositoryFactory
    }),
    methods: {
        getRepository(scope) {

            return this.repositoryFactory.get(scope)
        },
        getConectaSusRepository(scope = null) {

            return this.repositoryFactory.get(scope === null ? 'conectaSus' : `conectaSus.${scope}`)
        }
    },
    created() {

        this.repositoryFactory = repositoryFactory
    }
}